import {LiveFile} from "./file";

export interface ILiveImageDTO {
  original: string;
}

export class LiveImageDTO implements ILiveImageDTO{
  public original: string;
  constructor(data?: ILiveImageDTO) {
    if (data) {
      this.original = data.original;
    }
  }
}

export class LiveImage extends LiveFile {
  constructor(data: any) {
    if (data instanceof LiveImageDTO) {
      super(data.original);
    } else {
      super(data);
    }
  }

  get preview(): string {
    return this.url;
  }

  toString(): string {
    return this.preview;
  }
}

export class ImageDTO extends LiveImageDTO {
  large: string;
  medium: string;
}

export class Image extends LiveImage {
  protected _large: string;
  protected _medium: string;

  get large(): string {
    return this.isSaved ? this._large : this.url;
  }
  
  get medium(): string {
    return this.isSaved ? this._medium : this.url;
  }

  constructor(data: ImageDTO) {
    super(data);
    this._large = data.large;
    this._medium = data.medium;
  }
}


// WEBPACK FOOTER //
// ./src/api/image.ts